import React, { useEffect, useState } from "react";
import Api from "../../../utils/Api";
import { ApiDates } from "../../../utils/DateTimeUtil";
import PersonaMiniCard from "./PersonaMiniCard";

const ActiveUsersCard: React.FC<{ dateParams: ApiDates }> = (props) => {
  const [total, setTotal] = useState("0");

  useEffect(() => {
    // FIXME: https://familyzone.atlassian.net/browse/CF-434 - This call gets data from
    // FIXME: an actual appliance and hence is guaranteed to fail for cloud-only devices
    void Api.get_analyticsAsync("/surfwize/device/analytics/clients/users", { dateOverride: props.dateParams }).then(
      (resp: { data: unknown[] }) => {
        setTotal(String(resp.data?.length ?? 0));
      }
    );
  }, [props.dateParams]);

  return (
    <PersonaMiniCard total={total} title="Active Users" infoText="Active users on your network" viewLink="/surfwize/device/status/hosts" />
  );
};

export default ActiveUsersCard;
